import { FC } from "react";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsResourceCoverageDataLoadingSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataLoadingSelector";
import { resourceDetailsCoverageTabDataGridColumnDefs } from "@/components/pages/common/resource-details/components/content/coverage-content/components/data-grid/resourceDetailsCoverageTabDataGridColumnDefs";
import { resourceDetailsResourceCoverageGridDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageGridDataSelector";

export const ResourceDetailsCoverageTabDataGrid: FC = () => {
  const loading = useAppSelector(
    resourceDetailsResourceCoverageDataLoadingSelector,
  );
  const data = useAppSelector(resourceDetailsResourceCoverageGridDataSelector);

  return (
    <Stack spacing={1} height="100%">
      <Typography>Covered Commitments</Typography>

      <Box
        border={1}
        borderBottom={0}
        borderRadius={2}
        overflow="hidden"
        borderColor="grey.300"
      >
        {loading && <LinearProgress />}

        <AgDataGrid
          rowData={data}
          defaultColDef={defaultColDef}
          wrapperStyles={{ minHeight: 100 }}
          domLayout={data.length ? "autoHeight" : undefined}
          columnDefs={resourceDetailsCoverageTabDataGridColumnDefs}
        />
      </Box>
    </Stack>
  );
};

const defaultColDef = {
  flex: 1,
  minWidth: 135,
  sortable: false,
  unSortIcon: true,
  suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true,
};
